/* @flow */
'use strict';

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Key = require('interface-datastore').Key;

var readme = require('./shard-readme'); // eslint-disable-next-line

/*:: import type {Datastore, Callback} from 'interface-datastore'

export interface ShardV1 {
  name: string;
  param: number;
  fun(string): string;
  toString(): string;
}
*/


var PREFIX = exports.PREFIX = '/repo/flatfs/shard/';
var SHARDING_FN = exports.SHARDING_FN = 'SHARDING';
exports.README_FN = '_README';

var Shard =
/*#__PURE__*/
function () {
  /* :: name: string */

  /* :: param: number */

  /* :: _padding: string */
  function Shard(param
  /* : number */
  ) {
    _classCallCheck(this, Shard);

    this.param = param;
  }

  _createClass(Shard, [{
    key: "fun",
    value: function fun(str
    /* : string */
    )
    /* : string */
    {
      throw new Error('implement me');
    }
  }, {
    key: "toString",
    value: function toString()
    /* : string */
    {
      return "".concat(PREFIX, "v1/").concat(this.name, "/").concat(this.param);
    }
  }]);

  return Shard;
}();

var Prefix =
/*#__PURE__*/
function (_Shard) {
  _inherits(Prefix, _Shard);

  function Prefix(prefixLen
  /* : number */
  ) {
    var _this;

    _classCallCheck(this, Prefix);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Prefix).call(this, prefixLen));
    _this._padding = ''.padStart(prefixLen, '_');
    _this.name = 'prefix';
    return _this;
  }

  _createClass(Prefix, [{
    key: "fun",
    value: function fun(noslash
    /* : string */
    )
    /* : string */
    {
      return (noslash + this._padding).slice(0, this.param);
    }
  }]);

  return Prefix;
}(Shard);

var Suffix =
/*#__PURE__*/
function (_Shard2) {
  _inherits(Suffix, _Shard2);

  function Suffix(suffixLen
  /* : number */
  ) {
    var _this2;

    _classCallCheck(this, Suffix);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Suffix).call(this, suffixLen));
    _this2._padding = ''.padStart(suffixLen, '_');
    _this2.name = 'suffix';
    return _this2;
  }

  _createClass(Suffix, [{
    key: "fun",
    value: function fun(noslash
    /* : string */
    )
    /* : string */
    {
      var s = this._padding + noslash;
      return s.slice(s.length - this.param);
    }
  }]);

  return Suffix;
}(Shard);

var NextToLast =
/*#__PURE__*/
function (_Shard3) {
  _inherits(NextToLast, _Shard3);

  function NextToLast(suffixLen
  /* : number */
  ) {
    var _this3;

    _classCallCheck(this, NextToLast);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(NextToLast).call(this, suffixLen));
    _this3._padding = ''.padStart(suffixLen + 1, '_');
    _this3.name = 'next-to-last';
    return _this3;
  }

  _createClass(NextToLast, [{
    key: "fun",
    value: function fun(noslash
    /* : string */
    )
    /* : string */
    {
      var s = this._padding + noslash;
      var offset = s.length - this.param - 1;
      return s.slice(offset, offset + this.param);
    }
  }]);

  return NextToLast;
}(Shard);
/**
 * Convert a given string to the matching sharding function.
 *
 * @param {string} str
 * @returns {ShardV1}
 */


function parseShardFun(str
/* : string */
)
/* : ShardV1 */
{
  str = str.trim();

  if (str.length === 0) {
    throw new Error('empty shard string');
  }

  if (!str.startsWith(PREFIX)) {
    throw new Error("invalid or no path prefix: ".concat(str));
  }

  var parts = str.slice(PREFIX.length).split('/');
  var version = parts[0];

  if (version !== 'v1') {
    throw new Error("expect 'v1' version, got '".concat(version, "'"));
  }

  var name = parts[1];

  if (!parts[2]) {
    throw new Error('missing param');
  }

  var param = parseInt(parts[2], 10);

  switch (name) {
    case 'prefix':
      return new Prefix(param);

    case 'suffix':
      return new Suffix(param);

    case 'next-to-last':
      return new NextToLast(param);

    default:
      throw new Error("unkown sharding function: ".concat(name));
  }
}

exports.readShardFun = function (path
/* : string */
, store
/* : Datastore<Buffer> */
, callback
/* : Callback<ShardV1> */
)
/* : void */
{
  var key = new Key(path).child(new Key(SHARDING_FN));
  var get = typeof store.getRaw === 'function' ? store.getRaw.bind(store) : store.get.bind(store);
  get(key, function (err, res) {
    if (err) {
      return callback(err);
    }

    var shard;

    try {
      shard = parseShardFun((res || '').toString().trim());
    } catch (err) {
      return callback(err);
    }

    callback(null, shard);
  });
};

exports.readme = readme;
exports.parseShardFun = parseShardFun;
exports.Prefix = Prefix;
exports.Suffix = Suffix;
exports.NextToLast = NextToLast;